import {Routes, Route} from 'react-router-dom';
import CostFunctionIntro from "./CostFunctionIntro";

const CostFunctionRoutes = () => {
    return (
        <>
            <Routes>
                <Route path="/" element={<CostFunctionIntro/>}/>
            </Routes>
        </>
    )
}

export default CostFunctionRoutes;